import React from 'react'
import DataTable from 'react-data-table-component'

const DatatableMasterElements = (props) => {

    const columns = [
        {
            width: '18%',
            name: "Standard Akreditasi",
            selector: (row) => row?.chapters_accreditation?.standards_accreditation.Nama,
        },
        {
            width: '10%',
            name: "Nomor",
            selector: (row) => row.Nomor,
        },
        {
            width: '35%',
            name: "Deskripsi",
            selector: (row) => row.Deskripsi,
            wrap: true
        },
        {
            width: '18%',
            name: "Created At",
            selector: (row) => row.createdAt,
        },
        {
            width: '19%',
            name: "Updated At",
            selector: (row) => row.updatedAt,
        },
    ]

    return (
        <>
            <h5 className="card-title">Daftar Elemen</h5>
            <DataTable
                columns={columns}
                data={props.datas}
                pagination
                fixedHeader
                highlightOnHover
                subHeader
                subHeaderComponent={
                    <input
                        type="text"
                        placeholder="Search"
                        className='w-50 form-control m-3'
                        values={props.search}
                        onChange={(e) => {
                            // Hanya izinkan huruf, angka, dan spasi
                            const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                            props.handleChangeSearch(cleanValue);
                        }}
                    />
                }
                subHeaderAlign="center"
            />
        </>
    )
}

export default DatatableMasterElements
